/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SVGIcons } from "cms/icons/svg-icons";
import Config from "data/config";
import { PERMISSION } from "cms/auth/hooks/use-RBAC";

const conditionalItems = [];

if (Config.features.Dashboard.Enabled) {
    conditionalItems.push({
        name: "dashboard",
        icon: <SVGIcons.common.LineChart />,
        path: "/dashboard",
        permission: PERMISSION.GENERAL,
    });
}
if (Config.features.Tasks.Enabled) {
    conditionalItems.push({
        name: "tasks",
        icon: <SVGIcons.common.Tasks />,
        path: "/tasks",
        permission: PERMISSION.TASKS,
    });
}
if (Config.features.Composer.Enabled) {
    conditionalItems.push({
        name: "composer",
        icon: <SVGIcons.common.Composer />,
        path: "/composer",
        permission: PERMISSION.COMPOSER,
    });
}
if (Config.features.Websites.Enabled) {
    conditionalItems.push({
        name: "websites",
        icon: <SVGIcons.common.Websites />,
        path: "/websites",
        permission: PERMISSION.WEBSITE,
    });
}
if (Config.features.Forms.Enabled) {
    conditionalItems.push({
        name: "forms",
        icon: <SVGIcons.common.Forms />,
        path: "/forms",
        permission: PERMISSION.FORMS,
    });
}
if (Config.features.Digital_Assets.Enabled) {
    conditionalItems.push({
        name: "digital assets",
        icon: <SVGIcons.common.DigitalAssets />,
        path: "/digital-assets",
        permission: PERMISSION.DIGITAL_ASSETS,
        // children: [
        //   {
        //     name: "images",
        //     icon: <SVGIcons.fields.ImageField />,
        //     path: "/images",
        //   },
        //   {
        //     name: "documents",
        //     icon: <SVGIcons.fields.DocumentField />,
        //     path: "/documents",
        //   },
        // ]
    });
}
if (Config.features.Models.Enabled) {
    conditionalItems.push({
        name: "development",
        icon: <SVGIcons.common.Content />,
        path: "/development",
        permission: PERMISSION.MODEL_DESIGN,
    });
}
if (Config.features.Data.Enabled) {
    conditionalItems.push({
        name: "data",
        icon: <SVGIcons.common.Components />,
        path: "/data",
        permission: PERMISSION.DATA,
    });
}
if (Config.features.OrganizationsSettings.Enabled) {
    conditionalItems.push({
        name: "organization",
        icon: <SVGIcons.common.Organization/>,
        path: "/organization",
        permission: PERMISSION.ORGANIZATION,
    });
}
if (Config.features.Testing.Enabled) {
    conditionalItems.push({
        name: "testing",
        icon: <SVGIcons.common.Content/>,
        path: "/testing",
        permission: PERMISSION.SIMPLICITY_INTERNAL,
    });
}
if (Config.features.Components.Enabled) {
    conditionalItems.push({
        name: "components",
        icon: <SVGIcons.common.Components />,
        path: "/components",
        permission: PERMISSION.SIMPLICITY_INTERNAL,
    });
}

// {
//   name: "webpages",
//   icon: <SVGIcons.common.Websites />,
//   path: "/website/webpages",
//   permission: 'permission.?',
// },
// {
//     name: 'applications',
//     icon: <SVGIcons.common.Application />,
//     path: '/applications',
//     permission: 'permission.?',
// },
// {
//   name: "content",
//   icon: <SVGIcons.common.Content />,
//   path: "/content/edit",
//   permission: 'permission.?',
// },
// {
//     name: 'components',
//     icon: <SVGIcons.common.Components />,
//     path: '/components',
//     permission: 'permission.?',
// },

const navItems = [
    ...conditionalItems
];
export { navItems };
